/**
 * Cap meta descriptions (name="description", og:description,
 * twitter:description) at ~160 characters. Used at build time
 * (scripts/prerender-meta.mjs) and at render time (components/SEO.jsx) so the
 * prerendered head and the hydrated head agree. Post files are not edited;
 * visible page copy and JSON-LD keep the full text.
 */

export const META_DESCRIPTION_MAX = 160;

const TRAILING_JUNK = /[\s,;:\u2013\u2014-]+$/;

export function capMetaDescription(text, max = META_DESCRIPTION_MAX) {
  const clean = String(text == null ? "" : text)
    .replace(/<\/?[a-z][^>]*>/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (clean.length <= max) return clean;

  // Leave room for the ellipsis, then back up to the last word boundary.
  const hard = clean.slice(0, max - 1);
  const lastSpace = hard.lastIndexOf(" ");
  let cut = lastSpace >= Math.floor(max * 0.6) ? hard.slice(0, lastSpace) : hard;
  cut = cut.replace(TRAILING_JUNK, "");
  // Drop a dangling short connector ("and", "the", "of"…) before the ellipsis.
  cut = cut.replace(/\s+(?:a|an|and|or|the|of|to|in|for|with|on|at|by|from)$/i, "");
  if (/[.!?]$/.test(cut)) return cut;
  return `${cut.replace(/[.,;:]+$/, "")}…`;
}
